export const forwardingProps = {
  basename: "/link",
};
